import { SvgIcon, SvgIconProps } from '@mui/material';

const NaverSyncMenuIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{
        // 기본 opacity는 0.4
        color: '#FA2829',
        opacity: 0.4,
        transition: 'opacity 0.2s ease',
        // 부모에 .active 클래스가 있을 경우 opacity: 1
        '.active &': {
          opacity: 1,
        },
      }}
      {...props}
    >
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.5851 0H0.414892C0.184694 0 0 0.184694 0 0.414892V21.5851C0 21.8153 0.184694 22 0.414892 22H21.5851C21.8153 22 22 21.8126 22 21.5851V0.414892C22 0.184694 21.8153 0 21.5851 0ZM5.52744 5.37486V2.5643C5.52744 2.22168 5.80582 1.94063 6.15111 1.94063C6.49641 1.94063 6.77479 2.219 6.77479 2.5643V5.37486C6.77479 7.70629 8.66991 9.60141 11.0013 9.60141C13.3328 9.60141 15.2279 7.70629 15.2279 5.37486V2.5643C15.2279 2.22168 15.5063 1.94063 15.8516 1.94063C16.1969 1.94063 16.4752 2.219 16.4752 2.5643V5.37486C16.4752 8.39153 14.0207 10.8488 11.0013 10.8488C7.98199 10.8488 5.52744 8.39421 5.52744 5.37486ZM19.5749 19.7676H18.1643L15.7472 16.8018V19.7676H14.1197V14.7728H15.5304L17.9474 17.7949V14.7728H19.5749V19.7676Z"
          fill="#40B045"
        />
      </svg>
    </SvgIcon>
  );
};

export default NaverSyncMenuIcon;
